import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';

export const WrappedTypography = styled(Typography)(() => ({
  whiteSpace: 'normal',
  overflowWrap: 'break-word',
  wordBreak: 'break-word', // ensures even stubborn words break
  minWidth: 0,
  display: 'block',
}));
